import createPubSub from './createPubSub';

/**
 * @param {any} initialState
 * @returns {Object<string, function>}
 */
function createStateManager(initialState) {
  var _state = initialState;

  var _createPubSub = createPubSub(),
      subscribe = _createPubSub.subscribe,
      unsubscribe = _createPubSub.unsubscribe,
      publish = _createPubSub.publish;

  function getState() {
    return _state;
  }

  function setState(nextState) {
    _state = nextState;
    publish(_state);
  }

  return {
    getState: getState,
    setState: setState,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}

export default createStateManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/events/createStateManager.js
// module id = 790
// module chunks = 0